































import { Prop, Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import AdnuntiusPixels from '@/project/tracking/adnuntius/AdnuntiusPixels.vue';
import { CategoryItemViewModel } from '@/types/apiServerContract';
import megaMenuService from '@/project/shared/megaMenu.service';

@Component({
    components: { AdnuntiusPixels }
})
export default class CategoryBlockItem extends Vue {
    @Prop({
        type: Object
    }) content!: CategoryItemViewModel;

    categoryUrl: string | null = null;

    get icon(): string {
        return this.content.icon.url;
    }

    async getPageUrl() {
        let url;
        const campaignUrl = this.content.url ? await megaMenuService.getUrlForMenuItem(this.content.url) : null;

        if (this.content.url!.indexOf('c-') >= 0 && campaignUrl) {
            url = campaignUrl;
        } else {
            url = this.content.url;
        }

        return url;
    }

    get renderedPixelUrl() {
        return this.content?.renderedPixelUrl;
    }

    get viewPixelUrl() {
        return this.content?.viewPixelUrl;
    }

    get visiblePixelUrl() {
        return this.content?.visiblePixelUrl;
    }

    get clickPixelUrl() {
        return this.content?.clickPixelUrl;
    }

    async created() {
        this.categoryUrl = await this.getPageUrl();
    }
}
